import React from 'react';
import ImgComponent from '../components/ImgGenerationComponent/imgcomponent';


const Imagegenerationpage = () => {
  return (
    
    <div className="w-full h-screen flex justify-center items-center">
      
      <ImgComponent/>
    </div>
  );
};

export default Imagegenerationpage;
